import { useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { AnimateIn, Button } from '../../shared/ui';

export function StaffPortalUnavailablePage() {
  const { signOut } = useClerk();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] text-white px-6 py-20">
      <AnimateIn animation="fade-up" className="mx-auto max-w-md text-center">
        <img src="/logo-white.png" alt="RT Equipment & Haulage" className="h-10 w-auto mx-auto mb-8" />
        <p className="text-accent text-sm font-bold tracking-widest uppercase mb-4">Staff &amp; driver access</p>
        <h1 className="text-3xl sm:text-4xl font-black leading-tight tracking-tight mb-4">
          This account isn't available on the web
        </h1>
        <p className="text-white/60 text-sm leading-relaxed mb-10">
          Admin and driver access is provided through the RT Equipment &amp; Haulage mobile app, not
          this website. If you need help getting set up, reach out to us.
        </p>
        <div className="flex flex-col items-center gap-3">
          <Button to="/#contact" variant="marketing-primary" size="lg">
            Contact us
          </Button>
          <Button
            variant="ghost"
            size="md"
            className="!text-white/50 hover:!text-white"
            onClick={() => {
              void signOut(() => navigate('/'));
            }}
          >
            Sign out
          </Button>
        </div>
      </AnimateIn>
    </div>
  );
}
